import { $t } from '../../composables/i18n'
import CodebookValueNotFoundError from '../CodebookValueNotFoundError'
import { CountryId } from '../country/CountryId'

export enum IdentityTypeId {
  IDENTITY_CARD = 1,
  PASSPORT = 2,
  DRIVING_LICENSE = 3,
  PERMANENT_RESIDENCE = 4,
  RESIDENCE_PERMIT = 5,
  LOST_OR_THEFT_OF_DOCUMENT = 6,
  DIPLOMACY_STAFF = 7,
  CHILD_WITHOUT_DOCUMENT = 8,
}

export class IdentityType {
  static readonly IDENTITY_CARD = new IdentityType(
    IdentityTypeId.IDENTITY_CARD,
    () => $t('Identity card'),
    null,
  )
  static readonly PASSPORT = new IdentityType(IdentityTypeId.PASSPORT, () => $t('Passport'), null)
  static readonly DRIVING_LICENSE = new IdentityType(
    IdentityTypeId.DRIVING_LICENSE,
    () => $t('Driving license'),
    CountryId.HUN,
  )
  static readonly PERMANENT_RESIDENCE = new IdentityType(
    IdentityTypeId.PERMANENT_RESIDENCE,
    () => $t('Permanent residence'),
    null,
  )
  static readonly RESIDENCE_PERMIT = new IdentityType(
    IdentityTypeId.RESIDENCE_PERMIT,
    () => $t('Permanent permit'),
    CountryId.CZE,
  )
  static readonly LOST_OR_THEFT_OF_DOCUMENT = new IdentityType(
    IdentityTypeId.LOST_OR_THEFT_OF_DOCUMENT,
    () => $t('Lost or theft of document'),
    CountryId.CZE,
  )
  static readonly DIPLOMACY_STAFF = new IdentityType(
    IdentityTypeId.DIPLOMACY_STAFF,
    () => $t('Diplomacy staff'),
    CountryId.CZE,
  )
  static readonly CHILD_WITHOUT_DOCUMENT = new IdentityType(
    IdentityTypeId.CHILD_WITHOUT_DOCUMENT,
    () => $t('Child without document'),
    CountryId.CZE,
  )

  private constructor(
    public readonly id: IdentityTypeId,
    public readonly name: () => string,
    public readonly countryId: null | CountryId,
  ) {}

  static getById = (id: IdentityTypeId): IdentityType => {
    const value = IdentityType.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(IdentityType.name, id)
    }

    return value
  }

  static all = (): IdentityType[] => {
    return [
      IdentityType.IDENTITY_CARD,
      IdentityType.PASSPORT,
      IdentityType.DRIVING_LICENSE,
      IdentityType.PERMANENT_RESIDENCE,
      IdentityType.RESIDENCE_PERMIT,
      IdentityType.LOST_OR_THEFT_OF_DOCUMENT,
      IdentityType.DIPLOMACY_STAFF,
      IdentityType.CHILD_WITHOUT_DOCUMENT,
    ]
  }

  static allByCountryId = (countryId: number): IdentityType[] => {
    const countryIdentities: IdentityType[] = []
    IdentityType.all().forEach((identity) => {
      if (identity.countryId === null || identity.countryId === countryId) {
        countryIdentities.push(identity)
      }
    })

    return countryIdentities
  }

  static getIdentityTypeById(countryId: CountryId, identityTypeId: IdentityTypeId): IdentityType {
    return (
      this.allByCountryId(countryId).find((identityType) => identityType.id === identityTypeId) ??
      new IdentityType(identityTypeId, () => '', countryId)
    )
  }
}
